import { createFileRoute } from '@tanstack/react-router';
import { DetalheDoDocumento } from '@/features/documentos/componentes/DetalheDoDocumento';
import { LinkParaEnviar } from '@/features/pagamentos/componentes/NovoLink';
import { rotaDeTela } from '@/features/permissoes/guardas';

/**
 * Página do documento (spec 018, CA-04 a CA-06). O link de compra criado é desenhado pela tela de
 * pagamentos (copiar, WhatsApp, QR), composta aqui: uma funcionalidade não importa os componentes
 * de outra (ADR-0003).
 */
export const Route = createFileRoute('/_autenticado/documentos/$id')({
  ...rotaDeTela('documentos.lista'),
  component: Pagina,
});

function Pagina() {
  const { id } = Route.useParams();
  return (
    <DetalheDoDocumento key={id} id={id} linkGerado={(link) => <LinkParaEnviar link={link} />} />
  );
}
